import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.search.js";
import "core-js/modules/web.dom-collections.for-each.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { getBrand } from "@faire/help-center-utils/serialized-data/getBrand";
import { getRetailer } from "@faire/help-center-utils/serialized-data/getRetailer";
import { Column, Row } from "@faire/web--source/slate/Layout";
import { SearchInput } from "@faire/web--source/slate/SearchInput";
import { Spacer } from "@faire/web--source/slate/spacing";
import { Typography } from "@faire/web--source/slate/Typography";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import Fuse from "fuse.js";
import debounce from "lodash/debounce";
import map from "lodash/map";
import pick from "lodash/pick";
import React, { useEffect, useRef, useState } from "react";
import styled from "styled-components";
import { LinkedHelpCenterButton } from "../../components/HelpCenterButton/LinkedHelpCenterButton";
import { useClearNodesInLocalStorageOnLoad } from "../../hooks/useClearNodesInLocalStorageOnLoad";
import { useInstantAnswerContextAdditionalData } from "../../hooks/useInstantAnswerContextAdditionalData";
import { useMultipleNodesSetter } from "../../hooks/useMultipleNodesSetter";
import { useNavigation } from "../../hooks/useNavigation";
import { useSelectedNode } from "../../hooks/useSelectedNode";
import { useSelectedNodeAnswer } from "../../hooks/useSelectedNodeAnswer";
import { useSelfServeContext } from "../../hooks/useSelfServeContext";
import { findPathsFromSelectedNode } from "../../utils/findPathsFromSelectedNode";
import { ConfigurableOptions } from "./ConfigurableOptions";
import { getAllVisibleNodes } from "./getAllVisibleNodes";
var initSearchOptions = {
  isCaseSensitive: false,
  shouldSort: false,
  includeScore: false,
  includeMatches: false,
  findAllMatches: false,
  useExtendedSearch: false,
  minMatchCharLength: 1,
  location: 0,
  threshold: 0.6,
  distance: 100,
  keys: ["label", "metaData"]
};
export var IssueSearch = function IssueSearch() {
  useClearNodesInLocalStorageOnLoad();
  var _useSelfServeContext = useSelfServeContext(),
    context = _useSelfServeContext.context;
  var tree = context.tree;
  var _useState = useState(""),
    _useState2 = _slicedToArray(_useState, 2),
    searchValue = _useState2[0],
    setSearchValue = _useState2[1];
  var _useState3 = useState(initSearchOptions),
    _useState4 = _slicedToArray(_useState3, 2),
    searchOptions = _useState4[0],
    setSearchOptions = _useState4[1];
  var _useSelectedNode = useSelectedNode(),
    level1Node = _useSelectedNode.level1Node,
    level2Node = _useSelectedNode.level2Node,
    level3Node = _useSelectedNode.level3Node,
    level4Node = _useSelectedNode.level4Node,
    level5Node = _useSelectedNode.level5Node;
  var _React$useState = React.useState(false),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    nodeIsSelected = _React$useState2[0],
    setNodeIsSelected = _React$useState2[1];
  var _React$useState3 = React.useState([]),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    searchResult = _React$useState4[0],
    setSearchResult = _React$useState4[1];
  var _useState5 = useState([]),
    _useState6 = _slicedToArray(_useState5, 2),
    nodes = _useState6[0],
    setNodes = _useState6[1];
  var _useSelectedNodeAnswe = useSelectedNodeAnswer(),
    instantAnswer = _useSelectedNodeAnswe.instantAnswer;
  var _useInstantAnswerCont = useInstantAnswerContextAdditionalData(instantAnswer),
    instantAnswerContextAdditionalData = _useInstantAnswerCont.instantAnswerContextAdditionalData;
  useEffect(function () {
    var instantAnswerContext = _objectSpread({
      brandOrder: context.selectedBrandOrder,
      brand: getBrand(),
      retailer: getRetailer(),
      shouldDisplayCTAOfContactBrandOrRetailer: true
    }, instantAnswerContextAdditionalData);
    function getAllVisibleNodesAsync(_x) {
      return _getAllVisibleNodesAsync.apply(this, arguments);
    }
    function _getAllVisibleNodesAsync() {
      _getAllVisibleNodesAsync = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(context) {
        var allVisibleNodes;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return getAllVisibleNodes(context);
            case 2:
              allVisibleNodes = _context.sent;
              allVisibleNodes.map(function (node) {
                var _node$instantAnswer, _node$instantAnswer$d;
                var articleTitles = map(node.articles, function (article) {
                  return article.name;
                });
                var description = (_node$instantAnswer = node.instantAnswer) === null || _node$instantAnswer === void 0 ? void 0 : (_node$instantAnswer$d = _node$instantAnswer.descriptionBuilder) === null || _node$instantAnswer$d === void 0 ? void 0 : _node$instantAnswer$d.call(_node$instantAnswer, instantAnswerContext);
                if (Array.isArray(description)) {
                  var _node$instantAnswer$t, _node$instantAnswer2, _node$instantAnswer2$;
                  node.metaData = [(_node$instantAnswer$t = (_node$instantAnswer2 = node.instantAnswer) === null || _node$instantAnswer2 === void 0 ? void 0 : (_node$instantAnswer2$ = _node$instantAnswer2.titleBuilder) === null || _node$instantAnswer2$ === void 0 ? void 0 : _node$instantAnswer2$.call(_node$instantAnswer2, instantAnswerContext)) !== null && _node$instantAnswer$t !== void 0 ? _node$instantAnswer$t : ""].concat(_toConsumableArray(description !== null && description !== void 0 ? description : ""), _toConsumableArray(articleTitles)).filter(function (metaData) {
                    return metaData !== "";
                  });
                } else {
                  var _node$instantAnswer$t2, _node$instantAnswer3, _node$instantAnswer3$;
                  node.metaData = [(_node$instantAnswer$t2 = (_node$instantAnswer3 = node.instantAnswer) === null || _node$instantAnswer3 === void 0 ? void 0 : (_node$instantAnswer3$ = _node$instantAnswer3.titleBuilder) === null || _node$instantAnswer3$ === void 0 ? void 0 : _node$instantAnswer3$.call(_node$instantAnswer3, instantAnswerContext)) !== null && _node$instantAnswer$t2 !== void 0 ? _node$instantAnswer$t2 : ""].concat(_toConsumableArray(articleTitles)).filter(function (metaData) {
                    return metaData !== "";
                  });
                }
              });
              setNodes(allVisibleNodes);
            case 5:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return _getAllVisibleNodesAsync.apply(this, arguments);
    }
    getAllVisibleNodesAsync(context);
  }, [context, instantAnswerContextAdditionalData]);
  var searchableNodes = map(nodes, function (node) {
    return pick(node, ["id", "label", "metaData", "level"]);
  });
  var fuseRef = useRef(new Fuse(searchableNodes, searchOptions));
  var _useMultipleNodesSett = useMultipleNodesSetter(),
    setMultipleNodes = _useMultipleNodesSett.setMultipleNodes;
  var _useNavigation = useNavigation(),
    goToNextStep = _useNavigation.goToNextStep;
  var goToNextStepRef = useRef(goToNextStep);
  goToNextStepRef.current = goToNextStep;
  var searchOnChange = function searchOnChange(e) {
    var searchTerm = e.target.value;
    debounce(function () {
      return setSearchResult(fuseRef.current.search(searchTerm));
    }, 500)();
    setSearchValue(searchTerm);
  };
  useEffect(function () {
    fuseRef.current = new Fuse(searchableNodes, searchOptions);
  }, [searchOptions, searchableNodes]);
  useEffect(function () {
    if ((level1Node || level2Node || level3Node || level4Node || level5Node) && nodeIsSelected) {
      goToNextStepRef.current();
      setNodeIsSelected(false);
    }
  }, [level1Node, level2Node, level3Node, level4Node, level5Node, nodeIsSelected]);
  var handleHelpCenterButtonClick = function handleHelpCenterButtonClick(node) {
    var selectedNode = tree[node.id];
    if (selectedNode) {
      var allPaths = findPathsFromSelectedNode(tree, selectedNode);
      setMultipleNodes(allPaths);
      setNodeIsSelected(true);
    }
  };
  return /*#__PURE__*/React.createElement(Column, null, /*#__PURE__*/React.createElement(Row, {
    align: "center"
  }, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "xmcVZ0",
    defaultMessage: "Search"
  })), /*#__PURE__*/React.createElement(Spacer, {
    width: "2x"
  }), /*#__PURE__*/React.createElement(SearchInputWrapper, null, /*#__PURE__*/React.createElement(SearchInput, {
    value: searchValue,
    onChange: searchOnChange,
    onClear: function onClear() {
      return setSearchValue("");
    },
    placeholder: "Search issues or topics"
  }))), /*#__PURE__*/React.createElement(Spacer, {
    height: "1x"
  }), /*#__PURE__*/React.createElement(ConfigurableOptions, {
    searchOptions: searchOptions,
    setSearchOptions: setSearchOptions
  }), searchResult.map(function (_ref) {
    var item = _ref.item;
    return /*#__PURE__*/React.createElement(LinkedHelpCenterButton, {
      searchableNode: item,
      key: item.id,
      onClick: function onClick() {
        return handleHelpCenterButtonClick(item);
      }
    });
  }));
};
var SearchInputWrapper = styled.div.withConfig({
  displayName: "IssueSearch__SearchInputWrapper"
})(["width:100%;"]);